import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { ApplicationArtatech } from './application-artatech.model';
import { ApplicationArtatechPopupService } from './application-artatech-popup.service';
import { ApplicationArtatechService } from './application-artatech.service';

@Component({
    selector: 'dcs-application-artatech-delete-dialog',
    templateUrl: './application-artatech-delete-dialog.component.html'
})
export class ApplicationArtatechDeleteDialogComponent {

    application: ApplicationArtatech;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private applicationService: ApplicationArtatechService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['application']);
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete (id: number) {
        this.applicationService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'applicationListModification',
                content: 'Deleted an application'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'dcs-application-artatech-delete-popup',
    template: ''
})
export class ApplicationArtatechDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private applicationPopupService: ApplicationArtatechPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.applicationPopupService
                .open(ApplicationArtatechDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/application/application-artatech-delete-dialog.component.ts